import React, { useState } from "react";
import AddLoginCredential from "../components/AddLoginCredential";
// import DivisionalManagerList from "./DivisionalManagerList";
import AccountsManagerList from "./AccountsManagerList";
import FieldManagerList from "./FieldManagerList";
import BranchManagerList from "./BranchManagerList";
import Select from "react-select";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { IoSearch } from "react-icons/io5";
import CreditManagerList from "./CreditManagerList";
import CreditOfficerList from "../components/CreditOfficerList";
import MISList from "./MISList";
import SanctionCommitteeList from "./SanctionCommitteeList";
import { useAdminAuth } from "../../auth/AdminAuthProvider";

const LoginCredentials = () => {
  const [selectedRole, setSelectedRole] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { openSidebarToggle, toggleSidebar } = useAdminAuth();
  const [refreshList, setRefreshList] = useState(false);

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption.value || "");
  };

  const OpenSidebar = () => {
    toggleSidebar();
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader />
        </div>

        <div className="master-card-container">
          <div className="master-search-section">
            <div className="d-flex w-100">
              <div className="search-input-wrapper">
                <span className="search-icon">
                  <IoSearch />
                </span>
                <input
                  type="text"
                  placeholder="Search by any field"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
              </div>

              <div className="selectRole">
                <Select
                  value={selectedRole}
                  onChange={handleRoleChange}
                  options={[
                    { value: "Accounts Manager", label: "Accounts Manager" },
                    { value: "Sanction Committee", label: "Sanction Committee" },
                    { value: "Credit Manager", label: "Credit Manager" },
                    { value: "MIS", label: "MIS" },
                    { value: "Credit Officer", label: "Credit Officer" },
                    { value: "Branch Manager", label: "Branch Manager" },
                    {
                      value: "Customer Relationship Officer",
                      label: "Customer Relationship Officer",
                    },
                  ]}
                  isClearable
                  placeholder="--- Select Role ---"
                />
              </div>

              <div>
                <AddLoginCredential
                  onCredentialAdded={() => setRefreshList(!refreshList)}
                />
              </div>
            </div>
          </div>

          <div
            className="master-list-section"
            style={{
              overflowY: "auto",
              padding: "0 15px",
            }}
          >
            {selectedRole === "Accounts Manager" && (
              <AccountsManagerList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}

            {selectedRole === "MIS" && (
              <MISList searchQuery={searchQuery} refreshList={refreshList} />
            )}

            {selectedRole === "Sanction Committee" && (
              <SanctionCommitteeList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}

            {selectedRole === "Branch Manager" && (
              <BranchManagerList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}

            {selectedRole === "Credit Manager" && (
              <CreditManagerList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}

            {selectedRole === "Credit Officer" && (
              <CreditOfficerList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}

            {selectedRole === "Customer Relationship Officer" && (
              <FieldManagerList
                searchQuery={searchQuery}
                refreshList={refreshList}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginCredentials;
